import HomeAction from '../../redux/actions/HomeAction';
import ReSignActionType from '../../common/ResignActionType';
import ReSignService from '../../services/ReSignService';

const getCustomerInfo = token => (dispatch) => {
  if (!token) {
    return Promise.resolve().then(
      () => dispatch(HomeAction.storeError({ status: 'Error', message: 'No token', entity: {} }))
    );
  }
  return ReSignService.getCustomerInfo(token).then(
    (response) => {
      // eslint-disable-next-line no-console
      console.log(`getCustomerInfo() response: ${JSON.stringify(response)}`);
      dispatch(
        {
          type: ReSignActionType.STORE_CUSTOMER_INFO,
          value: response.entity
        }
      );
    },
    (error) => {
      // eslint-disable-next-line no-console
      console.error(`getCustomerInfo() error: ${JSON.stringify(error)}`);
      dispatch(HomeAction.storeError(error));
    }
  );
};

const reSign = token => (dispatch) => {
  if (!token) {
    return Promise.resolve().then(
      () => dispatch(HomeAction.storeError({ status: 'Error', message: 'No token', entity: {} }))
    );
  }
  return ReSignService.reSign(token).then(
    (response) => {
      // eslint-disable-next-line no-console
      console.log(`reSign() response: ${JSON.stringify(response)}`);
      dispatch(
        {
          type: ReSignActionType.STORE_RESIGN_RESPONSE,
          value: { status: 'Success' }
        }
      );
    },
    (error) => {
      // eslint-disable-next-line no-console
      console.error(`reSign() error: ${JSON.stringify(error)}`);
      dispatch(HomeAction.storeError(error));
    }
  );
};

export default {
  getCustomerInfo,
  reSign
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/ReSignAction.js
 **/